/*
  Big Deal Days tracking
  - GA4 (gtag) ecommerce: view_promotion, select_promotion, view_item_list, select_item, add_to_cart, add_to_wishlist
  - GTM dataLayer: same events in GA4 ecommerce format (with ecommerce reset)
  - Meta Pixel (fbq): ViewContent (product list) and AddToWishlist with event IDs (PageView, AddToCart, Purchase come from Shopify's Meta integration)
  - Shopify Customer Events: Shopify.analytics.publish('bdd_*') for custom pixels
  - UTM / click IDs: captured on landing, saved to the cart as attributes on first add to cart (they show on the order)
  Settings come from the "BDD Tracking" section (JSON in #bdd-tracking-config).
*/
(function () {
  if (window.BDDT) return;
  var cfgEl = document.getElementById('bdd-tracking-config');
  var cfg = { meta_id_format: 'product', ga4: true, gtm: true, meta: true, shopify: true, utm: true, ga4_id: 'G-ZL7QWY5TH9', meta_id: '330209582420494',
    list_id: 'big_deal_days', list_name: 'Big Deal Days', promo_id: 'big_deal_days_2026', promo_name: 'Big Deal Days 25% Off',
    coupon: 'DEAL25', currency: 'USD', id_format: 'shopify', market: 'US', debug: false };
  try { if (cfgEl) { var c = JSON.parse(cfgEl.textContent); for (var k in c) if (c[k] !== '' && c[k] != null) cfg[k] = c[k]; } } catch (e) {}

  var dl = window.dataLayer = window.dataLayer || [];
  function log() { if (cfg.debug && window.console) console.log.apply(console, ['[BDD tracking]'].concat([].slice.call(arguments))); }
  function uid(p) { return p + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

  /* ---------- loaders (only if the store hasn't already loaded them) ---------- */
  if (cfg.ga4 && typeof window.gtag !== 'function' && cfg.ga4_id) {
    window.gtag = function () { dl.push(arguments); };
    var g = document.createElement('script'); g.async = true; g.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.ga4_id);
    document.head.appendChild(g); gtag('js', new Date()); gtag('config', cfg.ga4_id);
  }
  if (cfg.meta && typeof window.fbq !== 'function' && cfg.meta_id) {
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', cfg.meta_id); fbq('track', 'PageView');
  }

  /* ---------- items ---------- */
  function idFor(d, fmt) {
    if (fmt === 'sku' && d.sku) return String(d.sku);
    if (fmt === 'variant') return String(d.vid);
    if (fmt === 'product') return String(d.pid);
    return 'shopify_' + cfg.market + '_' + d.pid + '_' + d.vid; /* Shopify's Google Merchant Center feed format */
  }
  function itemId(d) { return idFor(d, cfg.id_format); }
  function metaType() { var f = (!cfg.meta_id_format || cfg.meta_id_format === 'same') ? cfg.id_format : cfg.meta_id_format; return f === 'product' ? 'product_group' : 'product'; }
  function metaId(d) { return idFor(d, (!cfg.meta_id_format || cfg.meta_id_format === 'same') ? cfg.id_format : cfg.meta_id_format); }
  function cardData(card) { try { return JSON.parse(card.getAttribute('data-bdd-item')); } catch (e) { return null; } }
  function ga4Item(d, index, qty) {
    var it = { item_id: itemId(d), item_name: d.name, item_brand: d.brand || 'Pet N Pet', item_category: d.type || d.cat,
      item_category2: d.cat, item_variant: d.variant === 'Default Title' ? undefined : d.variant, item_list_id: cfg.list_id, item_list_name: cfg.list_name,
      promotion_id: cfg.promo_id, promotion_name: cfg.promo_name, coupon: cfg.coupon, price: d.price,
      discount: +(d.price - d.deal).toFixed(2), quantity: qty || 1, google_business_vertical: 'retail' };
    if (typeof index === 'number') it.index = index;
    if (d.badge) it.item_category3 = d.badge;
    return it;
  }
  function indexOf(card) { return Array.prototype.indexOf.call(document.querySelectorAll('.bdd-card'), card); }

  /* ---------- senders ---------- */
  function send(event, ecommerce, meta, extra) {
    var params = {}; var k;
    if (ecommerce) for (k in ecommerce) params[k] = ecommerce[k];
    if (extra) for (k in extra) params[k] = extra[k];
    if (cfg.ga4 && typeof window.gtag === 'function') { gtag('event', event, params); }
    if (cfg.gtm) {
      if (ecommerce) dl.push({ ecommerce: null });
      var o = { event: event }; if (ecommerce) o.ecommerce = ecommerce; if (extra) for (k in extra) o[k] = extra[k];
      dl.push(o);
    }
    if (cfg.shopify && window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try { Shopify.analytics.publish('bdd_' + event, params); } catch (e) {}
    }
    if (cfg.meta && meta && typeof window.fbq === 'function') {
      var opts = { eventID: meta.id || uid(meta.name) };
      if (meta.custom) fbq('trackCustom', meta.name, meta.data || {}, opts); else fbq('track', meta.name, meta.data || {}, opts);
    }
    log(event, params, meta || '');
  }

  /* ---------- UTM + click IDs ---------- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var SKEY = 'bdd_utm';
  function readStore() { try { return JSON.parse(localStorage.getItem(SKEY)) || null; } catch (e) { return null; } }
  function writeStore(o) { try { localStorage.setItem(SKEY, JSON.stringify(o)); } catch (e) {} }
  var utm = (function () {
    var q = new URLSearchParams(location.search), found = {}, any = false;
    UTM_KEYS.forEach(function (k) { var v = q.get(k); if (v) { found[k] = v.slice(0, 200); any = true; } });
    var stored = readStore();
    if (any) {
      found.landing_page = location.pathname; found.captured_at = new Date().toISOString();
      var o = { last: found, first: (stored && stored.first) || found, saved: false };
      writeStore(o); return o;
    }
    return stored;
  })();
  function saveUtmToCart() {
    if (!cfg.utm || !utm || utm.saved) return;
    var attrs = {}, l = utm.last || {}, f = utm.first || {};
    UTM_KEYS.forEach(function (k) { if (l[k]) attrs[k] = l[k]; });
    if (l.landing_page) attrs.landing_page = l.landing_page;
    if (f.utm_source) attrs.first_utm_source = f.utm_source;
    if (f.utm_campaign) attrs.first_utm_campaign = f.utm_campaign;
    attrs.promo_page = cfg.promo_id;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (r.ok) { utm.saved = true; writeStore(utm); log('UTM saved to cart', attrs); } }).catch(function () {});
  }

  /* ---------- wiring ---------- */
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  onReady(function () {
    /* Banner promotions */
    var slides = document.querySelectorAll('.bdd-slide');
    var seenSlides = [];
    function promo(slide) {
      var i = Array.prototype.indexOf.call(slides, slide);
      var name = (slide.getAttribute('aria-label') || '').trim();
      return { promotion_id: cfg.promo_id, promotion_name: cfg.promo_name, creative_name: name, creative_slot: 'banner_slide_' + (i + 1), location_id: 'bdd_banner_slider' };
    }
    if ('IntersectionObserver' in window && slides.length) {
      var so = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6 && seenSlides.indexOf(en.target) === -1 && !en.target.hidden) {
            seenSlides.push(en.target);
            send('view_promotion', { items: [promo(en.target)] }, null, promo(en.target));
          }
        });
      }, { threshold: [0.6] });
      slides.forEach(function (s) { so.observe(s); });
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.bdd-slide-link');
      if (link) { var p = promo(link.closest('.bdd-slide')); send('select_promotion', { items: [p] }, null, p); }
    }, true);

    /* Product list impression (once, when the grid is on screen) */
    var grid = document.querySelector('.bdd-grid');
    if (grid) {
      var fired = false;
      var fireList = function () {
        if (fired) return; fired = true;
        var cards = Array.prototype.slice.call(document.querySelectorAll('.bdd-card'));
        var datas = cards.map(cardData).filter(Boolean);
        var items = datas.map(function (d, i) { return ga4Item(d, i); });
        /* GA4 accepts up to 200 items per event; send in chunks of 25 to keep payloads small */
        for (var i = 0; i < items.length; i += 25) {
          send('view_item_list', { item_list_id: cfg.list_id, item_list_name: cfg.list_name, items: items.slice(i, i + 25) },
            i === 0 ? { name: 'ViewContent', data: { content_type: metaType(), content_ids: datas.map(metaId), content_name: cfg.list_name, content_category: 'Promotion', currency: cfg.currency,
              contents: datas.map(function (d) { return { id: metaId(d), quantity: 1, item_price: d.price }; }) } } : null);
        }
      };
      if ('IntersectionObserver' in window) {
        var go = new IntersectionObserver(function (ents) { if (ents.some(function (en) { return en.isIntersecting; })) { fireList(); go.disconnect(); } }, { threshold: 0.15 });
        go.observe(grid);
      } else fireList();
    }

    /* Product click */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.bdd-card a');
      if (!a) return;
      var card = a.closest('.bdd-card'), d = cardData(card); if (!d) return;
      send('select_item', { item_list_id: cfg.list_id, item_list_name: cfg.list_name, items: [ga4Item(d, indexOf(card))] }, null);
    }, true);

    /* Wishlist */
    document.addEventListener('click', function (e) {
      var w = e.target.closest && e.target.closest('.bdd-wish');
      if (!w) return;
      setTimeout(function () {
        if (!w.classList.contains('is-wished')) return;
        var card = w.closest('.bdd-card'), d = cardData(card); if (!d) return;
        send('add_to_wishlist', { currency: cfg.currency, value: d.price, items: [ga4Item(d, indexOf(card))] },
          { name: 'AddToWishlist', data: { content_type: metaType(), content_ids: [metaId(d)], content_name: d.name, value: d.price, currency: cfg.currency } });
      }, 0);
    }, true);

    /* Filter chips (custom event) */
    document.addEventListener('click', function (e) {
      var f = e.target.closest && e.target.closest('[data-bdd-filter]');
      if (f) send('bdd_filter', null, null, { filter_name: f.textContent.trim(), item_list_name: cfg.list_name });
    }, true);
  });

  /* Add to cart (dispatched by the product grid after Shopify confirms the add) */
  document.addEventListener('bdd:add-to-cart', function (e) {
    var card = e.detail && e.detail.card, res = e.detail && e.detail.response;
    var d = card && cardData(card); if (!d) return;
    var qty = (res && res.quantity) || 1;
    var vid = res && res.variant_id; if (vid) d.vid = vid;
    if (res && typeof res.price === 'number') d.price = res.price / 100;
    var item = ga4Item(d, indexOf(card), qty);
    var key = res && res.key ? String(res.key).split(':')[0] : '';
    /* Meta AddToCart is NOT sent here: Shopify's Meta (Facebook & Instagram) integration already sends it for every add to cart. */
    send('add_to_cart', { currency: cfg.currency, value: +(d.price * qty).toFixed(2), items: [item] }, null);
    saveUtmToCart();
  });

  window.BDDT = { config: cfg, send: send, utm: function () { return utm; } };
})();
